/**
 * Whether a page is showing the phone's call at full size right now (the Phone page's stage).
 *
 * The dock opens itself for a ringing call so that a call is never missed behind a closed
 * popover. On the Phone page the stage already shows the ringing call, at 44px Answer buttons,
 * so a popover opening over it would be the same call twice. The page says it is here; the dock
 * reads it. A module store rather than a router lookup, because the dock is also rendered where
 * there is no router (`/dev/phone`), and the page is the one thing that knows it is mounted.
 */
import * as React from "react";

let mounted = 0;
const watchers = new Set<() => void>();

export function markStageMounted(on: boolean): void {
  mounted = Math.max(0, mounted + (on ? 1 : -1));
  for (const notify of watchers) notify();
}

const subscribe = (notify: () => void) => {
  watchers.add(notify);
  return () => {
    watchers.delete(notify);
  };
};

export function useStageMounted(): boolean {
  return React.useSyncExternalStore(subscribe, () => mounted > 0, () => false);
}

/** Registers the stage for as long as the component is mounted. */
export function useMarkStage(): void {
  React.useEffect(() => {
    markStageMounted(true);
    return () => markStageMounted(false);
  }, []);
}
